import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

export default {
  /**
   * Obtiene lista de torneos disponibles
   * @returns {Promise} Lista de torneos
   */
  async getTournaments () {
    const url = `${API_BASE}/club_house_tournaments/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching tournaments:', error)
      throw error
    }
  },

  /**
   * Obtiene detalles de un torneo específico
   * @param {string|number} tournamentId - ID del torneo
   * @returns {Promise} Detalles del torneo
   */
  async getTournamentById (tournamentId) {
    const url = `${API_BASE}/club_house_tournaments/${tournamentId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching tournament:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de miembros de Casa Club
   * @returns {Promise} Lista de miembros
   */
  async getClubMembers () {
    const url = `${API_BASE}/club_house_members/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching club members:', error)
      throw error
    }
  },

  /**
   * Obtiene información general de Casa Club
   * @returns {Promise} Información de la casa club
   */
  async getClubInfo () {
    const url = `${API_BASE}/club_house_info/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching club info:', error)
      throw error
    }
  },

  /**
   * Registra un usuario a un torneo
   * @param {string|number} tournamentId - ID del torneo
   * @returns {Promise} Confirmación de registro
   */
  async registerToTournament (tournamentId) {
    const url = `${API_BASE}/tournament_registration/`

    try {
      const response = await axios.post(url, {
        tournament_id: tournamentId
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error registering to tournament:', error)
      throw error
    }
  },

  /**
   * Obtiene invitaciones de Casa Club
   * @returns {Promise} Lista de invitaciones
   */
  async getClubInvitations () {
    const url = `${API_BASE}/club_house_invitations/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching club invitations:', error)
      throw error
    }
  },

  /**
   * Obtiene información de amenidades de Casa Club
   * @returns {Promise} Lista de amenidades
   */
  async getClubAmenities () {
    const url = `${API_BASE}/club_house_amenities/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching club amenities:', error)
      throw error
    }
  },

  /**
   * Obtiene accesos a Casa Club
   * @returns {Promise} Lista de accesos
   */
  async getClubAccesses () {
    const url = `${API_BASE}/club_house_accesses/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching club accesses:', error)
      throw error
    }
  }
}
